import React from "react";

import { NavLink } from "react-router-dom";
import { Box, Container, Flex, Text } from "theme-ui";

import { useIsMobile } from "../../hooks/useIsMobile";
import { useAstridDao } from "../../providers/AstridDaoProvider";
import { Icon } from "../Icon";
import ExternalLink from "./ExternalNavLink";
import { navIconStyles } from "./SideBar";

export const SideBarExternalLinks = ({
  currentPath,
  onClick
}: {
  currentPath: string;
  onClick?: Function;
}) => {
  const { isTestnet } = useAstridDao();
  const isMobile = useIsMobile()

  return (
    <Container
      sx={{
        width: "100%",
        borderRadius: "12px"
      }}
    >
      <Flex
        sx={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          mt: 5
        }}
      >
        {isTestnet && (
          <Box
            sx={{
              mt: 3,
              p: 3,
              bg: currentPath === "/bai-conversion" ? "G12" : "transparent",
              borderRadius: "card",
              width: isMobile ? 'calc(100vw - 24px)' : ["0px", "172px", "220px"],
              ":hover": {
                background: "G05"
              }
            }}
            onClick={() => {
              onClick && onClick();
            }}
          >
            <NavLink className={({ isActive }) => (isActive ? "active" : "")} to="/bai-conversion">
              <Flex sx={{}}>
                {/* <Icon style={navIconStyles} name="retweet" /> */}
                <Text
                  variant={currentPath === "/bai-conversion" ? "text.mediumH3" : "text.regularH3"}
                  sx={{
                    color: currentPath === "/bai-conversion" ? "B100" : "B60"
                  }}
                >
                  Convert xcBAI
                </Text>
              </Flex>
            </NavLink>
          </Box>
        )}

        <ExternalLink to="https://astar.sio2.finance/">
          <Box
            sx={{
              mt: 3,
              p: 3,
              width: isMobile ? 'calc(100vw - 24px)' : ["0px", "172px", "220px"],
              ":hover": {
                background: "G05",
                borderRadius: "card"
              }
            }}
          >

            <Text
              variant="text.regularH3"
              sx={{
                color: "B60"
              }}
            >
              {/* <Icon style={navIconStyles} name="hand-holding-dollar" /> */}
              Lending <Icon name="external-link-alt" size="xs" />
            </Text>
          </Box>
        </ExternalLink>

        <ExternalLink to="https://www.sirius.finance/">
          <Box
            sx={{
              mt: 3,
              p: 3,
              width: isMobile ? 'calc(100vw - 24px)' : ["0px", "172px", "220px"],
              ":hover": {
                background: "G05",
                borderRadius: "card"
              }
            }}
          >
            <Text
              variant="text.regularH3"
              sx={{
                color: "B60"
              }}
            >
              {/* <Icon style={navIconStyles} name="money-bill-transfer" /> */}
              Stable Swap <Icon name="external-link-alt" size="xs" />
            </Text>
          </Box>
        </ExternalLink>

        <ExternalLink to="https://app.arthswap.org/#/swap">
          <Box
            sx={{
              mt: 3,
              p: 3,
              width: isMobile ? 'calc(100vw - 24px)' : ["0px", "172px", "220px"],
              ":hover": {
                background: "G05",
                borderRadius: "card"
              }
            }}
          >
            <Text
              variant="text.regularH3"
              sx={{
                color: "B60"
              }}
            >
              {/* <Icon style={navIconStyles} name="circle-nodes" /> */}
              DEX <Icon name="external-link-alt" size="xs" />
            </Text>
          </Box>
        </ExternalLink>
      </Flex>
    </Container>
  );
};
